import { styled as muiStyled } from '@mui/material'

const ImgElement = muiStyled('img')({
    //draggable: false,
})

export default ImgElement
